import * as z from "zod"

export const FrontConversationModel = z.object({
  id: z.number().int(),
  created_at: z.date(),
  updated_at: z.date(),
  front_id: z.string(),
  subject: z.string().nullish(),
  request_id: z.number().int().nullish(),
})
